import { LoaderFunction } from 'react-router-dom';

import { fetchGraphQL } from 'src/services/contentful/client';
import { ContentHubType } from 'src/constants';
import { isPreviewMode } from 'src/utils/isPreviewMode';
import {
  ContentfulFlexibleContentHub,
  GET_FLEXIBLE_CONTENT_HUB_COLLECTION,
  GetFlexibleContentHubCollectionResponse,
} from 'src/graphql/queries/GetFlexibleContentHub';
import { GetFlexibleContentHubCollectionQueryVariables } from 'src/graphql/generated/GetFlexibleContentHub';

export interface JiraHubLoaderProps {
  jiraHubData: ContentfulFlexibleContentHub;
}

const getJiraHubData = async (type: string, preview: boolean): Promise<ContentfulFlexibleContentHub | undefined> => {
  const response = await fetchGraphQL<
    GetFlexibleContentHubCollectionResponse,
    GetFlexibleContentHubCollectionQueryVariables
  >(GET_FLEXIBLE_CONTENT_HUB_COLLECTION, {
    preview,
    type,
  });

  return response.flexibleContentHubCollection.items[0];
};

export const loader: LoaderFunction = async (): Promise<JiraHubLoaderProps> => {
  const preview = isPreviewMode();

  const jiraHubData = await getJiraHubData(ContentHubType.JIRA, preview);

  if (!jiraHubData) {
    throw new Error('Jira Hub was not found');
  }

  return { jiraHubData };
};
